<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.storeName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称">
                <a-input v-model="queryParam.merchantName" placeholder="请输入商家名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="要货单号">
                <a-input v-model="queryParam.purchaseOrderNo" placeholder="请输入要货单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['retail:purchase:add']">
          <a-icon type="plus" />创建退货单
        </a-button>
      </div>

      <!-- 表格 -->
      <a-table
        :columns="columns"
        :row-key="record => record.id"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        :scroll="{ x: 1400 }"
        @change="handleTableChange"
      >
        <template slot="returnAmount" slot-scope="text">
          ¥{{ text }}
        </template>
        <template slot="createTime" slot-scope="text">
          {{ parseTime(text) }}
        </template>
        <template slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:purchase:detail']">详情</a>
        </template>
      </a-table>
    </a-card>

    <!-- 创建退货单弹窗 -->
    <create-form ref="createForm" @ok="handleQuery" />

    <!-- 退货单详情弹窗 -->
    <detail-modal ref="detailModal" />
  </page-header-wrapper>
</template>

<script>
import { getReturnList } from '@/api/retail/purchase'
import CreateForm from './modules/CreateReturnForm'
import DetailModal from './modules/ReturnDetailModal'

export default {
  name: 'PurchaseReturn',
  components: {
    CreateForm,
    DetailModal
  },
  data() {
    return {
      // 查询参数
      queryParam: {
        storeName: undefined,
        merchantName: undefined,
        purchaseOrderNo: undefined
      },
      // 表头
      columns: [
        {
          title: '退货单号',
          dataIndex: 'returnNo',
          align: 'center',
          width: 170
        },
        {
          title: '要货单号',
          dataIndex: 'purchaseOrderNo',
          align: 'center',
          width: 170
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          align: 'center',
          width: 120
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          align: 'center',
          width: 120
        },
        {
          title: '退货金额',
          dataIndex: 'returnAmount',
          align: 'center',
          width: 110,
          scopedSlots: { customRender: 'returnAmount' }
        },
        {
          title: '退货时间',
          dataIndex: 'returnTime',
          align: 'center',
          width: 160
        },
        {
          title: '创建人',
          dataIndex: 'creatorName',
          align: 'center',
          width: 100
        },

        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
          ellipsis: true,
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 80,
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 数据
      data: [],
      // 分页
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      // 加载中
      loading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    /**
     * 加载数据
     */
    loadData() {
      this.loading = true
      const params = {
        ...this.queryParam,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      getReturnList(params).then(res => {
        this.data = res.data.records
        this.pagination.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },

    /**
     * 查询
     */
    handleQuery() {
      this.pagination.current = 1
      this.loadData()
    },

    /**
     * 重置
     */
    resetQuery() {
      this.queryParam = {
        storeName: undefined,
        merchantName: undefined,
        purchaseOrderNo: undefined
      }
      this.handleQuery()
    },

    /**
     * 表格变化
     */
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },

    /**
     * 详情
     */
    handleDetail(record) {
      this.$refs.detailModal.open(record.id)
    },

    /**
     * 格式化时间
     */
    parseTime(time) {
      if (!time) return ''
      return this.$moment(time).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-page-search-submitButtons {
  display: block;
  white-space: nowrap;
}

.table-operations {
  margin-bottom: 16px;
}
</style>
